import { gql } from '@apollo/client'
import { MINIMAL_STORE_FRAGMENT } from '../fragments/MinimalStoreFragment'

export const UPDATE_COMPANY_STORE = gql`
  mutation UpdateCompanyStore($input: UpdateCompanyStoreInput!) {
    updateCompanyStore(input: $input) {
      store {
        ...Store
      }
    }
  }
  ${MINIMAL_STORE_FRAGMENT}
`
